import React from "react";
import HeaderCities from "../components/HeaderCities";
import CarpetRemovalFAQs from "../components/CarpetRemovalFAQs";
import ServicesArea from "../components/ServicesArea";
import UpperFooter from "../components/UpperFooter";
import "../assets/css/services.css";

function Carpet() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Need carpet removal? We offer fast, affordable, and eco-friendly carpet removal services for homeowners and businesses. Get a free quote today."
        />
        <base href="/" />

        <link
          rel="preload"
          as="image"
          href="/assets/img/Carpet-removal.webp"
          type="image/webp"
        />
        <link
          rel="canonical"
          href="https://junkdroid.com/services/carpet-disposal/"
        />

        <title>Carpet Removal | Fast & Affordable | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Hero Section Start HERE =========================  */}
        <div className="container-fluid madeesay-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Services</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Carpet Removal
                    </li>
                  </ol>
                </nav>
                <h1>
                  Carpet Disposal <span>Made Easy</span>
                </h1>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <div className="inner-img">
                  <img src="/assets/img/Carpet-removal.webp" alt="Carpet" />
                </div>
                <p>
                  Need carpet disposal services? Whether you're upgrading to
                  hardwood floors, laminate flooring, or vinyl flooring, our
                  carpet removal service makes clearing out your space quick and
                  hassle-free. From small rooms to large commercial spaces, we
                  handle it all with professional care.
                </p>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                    <a href="tel:4085397261">
                      <button type="button" className="btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                          />
                        </svg>{" "}
                        &nbsp; CALL NOW
                      </button>
                    </a>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                    <h4>Rated 5.0 on Google</h4>
                    <div className="rating-sec">
                      <span>5.0</span> &nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill ms-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 desk-img">
                <img src="/assets/img/Carpet-removal.webp" alt="Carpet" />
              </div>
            </div>
          </div>
        </div>
        {/* ================== Hero Section End HERE =========================  */}
        {/* ================== First  Section Start HERE =========================  */}
        <hr />
        <div className="container-fluid overview-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="major-heading">
                  <span>Carpet Removal Service</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Our expert team specializes in the safe and efficient removal
                  of all types of carpets, ensuring a stress-free experience. We
                  handle everything from removing old carpet and padding to
                  tackling tough tack strips, gripper rods, and stubborn
                  adhesives.
                </p>
                <p className="service-description">
                  We offer convenient pick-up and disposal services, making the
                  carpet removal process effortless. Whether you're renovating,
                  redecorating, or preparing a property for new tenants, we take
                  care of the heavy lifting. Our carpet removers use the right
                  tools, including utility knives, pry bars, flat head
                  screwdrivers, and long-handled floor scrapers, to ensure a
                  smooth removal process.
                </p>
                <p className="service-description">
                  Committed to eco-friendly disposal, we partner with recycling
                  centers and responsible disposal facilities to minimize waste
                  and reduce environmental impact.
                </p>
                {/* ============ */}
                <h3>
                  Why Choose Our <span>Carpet Removers?</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Expert Team:</span>&nbsp;Our professionals are highly
                    trained to remove carpets efficiently and safely from any
                    space, including homes and businesses.
                  </li>
                  <li>
                    <span>Affordable Pricing:</span>&nbsp;We provide
                    transparent, upfront quotes with no hidden fees. Get a free
                    estimate based on your square footage or square metre.
                  </li>
                  <li>
                    <span>Eco-Friendly Disposal:</span>&nbsp;We work with
                    licensed facilities to recycle or responsibly dispose of old
                    carpets, padding, and adhesives.
                  </li>
                  <li>
                    <span>Flexible Scheduling:</span>&nbsp;Need same-day
                    service? We offer convenient scheduling, including weekend
                    appointments, to fit your timeline.
                  </li>
                  <li>
                    <span>Great Service:</span>&nbsp;From start to finish, we
                    handle your property with care and ensure a clean,
                    debris-free space after removal.
                  </li>
                </p>
                {/* ============ */}
                <h3>
                  How It <span>Works</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Get a Free Quote:</span>&nbsp;Contact us for a free
                    estimate based on the size, carpet type, and condition of
                    your carpet.
                  </li>
                  <li>
                    <span>Schedule Your Carpet Removal Service:</span>
                    &nbsp;Choose a convenient time, including same-day or
                    next-day service.
                  </li>
                  <li>
                    <span>We Handle the Heavy Lifting:</span>&nbsp;Our carpet
                    removers arrive with the right tools, safety glasses, dust
                    masks, knee pads, and other personal protective equipment to
                    efficiently remove carpets, padding, and adhesives.
                  </li>
                  <li>
                    <span>Payment:</span>&nbsp;We accept cash, debit, credit,
                    check, and Zelle.
                  </li>
                  <li>
                    <span>Eco-Friendly Disposal:</span>&nbsp;We recycle or
                    dispose of materials responsibly to minimize waste.
                  </li>
                </p>
                {/* ===================================================================================0 */}
                <h3>
                  Service <span>Area</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>We proudly serve homes and properties in:</p>
                {/* ===================================================================================0 */}
                <ServicesArea />
                <div className="row">
                  <div className="col-md-12 overview-sec service-desc">
                    <h3 className="pt-0">
                      Book Your Carpet <span>Removal Today!</span>
                    </h3>
                    <div className="sliderline-svg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={64}
                        height={4}
                        viewBox="0 0 64 4"
                        fill="none"
                      >
                        <path
                          d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                          fill="#60BDFF"
                        />
                      </svg>
                    </div>
                    <p>
                      Say goodbye to cardboard clutter with Junk Droid’s easy
                      and affordable cardboard recycling services. Contact us
                      now for same-day pickup and great service!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ================== First  Section End HERE =========================  */}
        {/* ================= What We Take Section Start Here ================= */}
        <div className="container-fluid more-detail-sec we-take-sec">
          <div className="container junk-container">
            <div className="row">
              <div className="col-md-12">
                <h2>What We Take</h2>
                <div className="line-svg what-take-line">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card bbq-card-sec pile-card-sec">
                  <h4>Standard Residential Carpets</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Loop Pile Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Cut Pile Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Berber Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Frieze Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Plush Carpets</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}

              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card paper-card">
                  <h4>Commercial Carpets</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Commercial Loop Pile Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Commercial Cut Pile Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Carpet Tiles</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Axminster Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Nylon or Polyester Commercial Carpets</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card carp-card-sec">
                  <h4>Outdoor and Indoor-Outdoor Carpets</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Outdoor Rugs</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Indoor-Outdoor Carpets</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card card-carp-sec">
                  <h4>Area Rugs and Mats</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Large Area Rugs</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Small Area Rugs</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Throw Rugs</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card">
                  <h4>Carpets with Specific Material Types</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Wool Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Synthetic Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Cotton Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Silk and Velvet Carpets</span>
                    </div>
                  </li>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card cardb-card carp-sect">
                  <h4>Carpets with Specific Construction Types</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Woven Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Tufted Carpets</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Needle-Punched Carpets</span>
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ===================== What We Take Section End Here ================ */}

        {/* ================== FAQ's Section Start HERE =========================  */}
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2>
                  Cardboard Pickup <span>FAQs</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              <CarpetRemovalFAQs />
            </div>
          </div>
        </div>
        <UpperFooter />
      </>
    </div>
  );
}

export default Carpet;
